import { printSyntax, walkSyntax, } from "@icg360/pi-syntax-tools";
import { PathError } from "../errors";
const staticProperties = [
    "key",
    "name",
    "default",
    "initial",
    "meta",
    "separator",
];
export const extractDependencies = (expression, thisContext) => {
    var _a, _b;
    const dependencies = [];
    pathLoop: for (const path of walkSyntax(expression)) {
        if (path.type !== "path") {
            continue;
        }
        const location = {
            type: "term",
        };
        let nextPathItem = undefined;
        for (const item of path.items) {
            if (item.type === "predicate" ||
                (item.type === "identifier" && item.value === "meta") ||
                (nextPathItem === "property" &&
                    staticProperties.includes(item.value)) ||
                (item.type === "identifier" && item.value === "env") ||
                (nextPathItem === "thisContext" && item.value === "event") ||
                (nextPathItem === "thisContext" && item.value === "index") ||
                (nextPathItem === "thisContext" && item.value === "position")) {
                // Not going to follow predicates for now
                // Not going to listen to meta changes
                // For now, not going to listen to env changes
                continue pathLoop;
            }
            if (item.type === "identifier") {
                if (item.value === "terms") {
                    nextPathItem = "termName";
                    continue;
                }
                if (item.value === "iterables") {
                    nextPathItem = "iterableName";
                    continue;
                }
                if (item.value === "this") {
                    nextPathItem = "thisContext";
                    continue;
                }
            }
            if (item.type === "property") {
                if (nextPathItem === "thisContext") {
                    if (item.value === "term") {
                        location.type = thisContext.iterable ? "iterable-term" : "term";
                        location.termName = (_a = thisContext.term) === null || _a === void 0 ? void 0 : _a.name;
                        location.iterableName = (_b = thisContext.iterable) === null || _b === void 0 ? void 0 : _b.name;
                        nextPathItem = "property";
                        continue;
                    }
                    if (item.value === "iterable") {
                        if (!thisContext.iterable) {
                            throw new PathError(`Cannot get iterable from term: ${printSyntax(path)}`, path, expression);
                        }
                        location.type = "iterable";
                        location.iterableName = thisContext.iterable.name;
                        nextPathItem = "iterableProperty";
                        continue;
                    }
                    if (item.value === "terms") {
                        if (!thisContext.iterable) {
                            throw new PathError(`Cannot get iterable from term: ${printSyntax(path)}`, path, expression);
                        }
                        location.type = "iterable-term";
                        location.iterableName = thisContext.iterable.name;
                        nextPathItem = "termName";
                        continue;
                    }
                }
                if (nextPathItem === "termName") {
                    location.termName = item.value;
                    nextPathItem = "property";
                    continue;
                }
                if (nextPathItem === "iterableName") {
                    location.iterableName = item.value;
                    nextPathItem = "iterableProperty";
                    continue;
                }
                if (nextPathItem === "iterableProperty") {
                    // TODO: do something different if the property is "instances"
                    if (item.value === "instances") {
                        continue pathLoop;
                    }
                    location.type = "iterable";
                    location.property = item.value;
                    break;
                }
                if (nextPathItem === "property") {
                    location.property = item.value;
                    break;
                }
            }
        }
        if (!location.property) {
            throw new PathError(`Missing property in path: ${printSyntax(path)}`, path, expression);
        }
        if (location.type === "term") {
            if (!location.termName) {
                throw new PathError(`Missing term name in path: ${printSyntax(path)}`, path, expression);
            }
            dependencies.push({
                type: "term",
                termName: location.termName,
                property: mapTermProperty(location.property, path, expression),
            });
        }
        if (location.type === "iterable-term") {
            if (!location.termName) {
                throw new PathError(`Missing term name in path: ${printSyntax(path)}`, path, expression);
            }
            if (!location.iterableName) {
                throw new PathError(`Missing iterable name in path: ${printSyntax(path)}`, path, expression);
            }
            dependencies.push({
                type: "iterable-term",
                iterableName: location.iterableName,
                termName: location.termName,
                property: mapTermProperty(location.property, path, expression),
            });
        }
        if (location.type === "iterable") {
            if (!location.iterableName) {
                throw new PathError(`Missing iterable name in path: ${printSyntax(path)}`, path, expression);
            }
            dependencies.push({
                type: "iterable",
                iterableName: location.iterableName,
                property: mapIterableProperty(location.property, path, expression),
            });
        }
    }
    return dependencies;
};
const termPropertiesThatCanBeReferencedInExpressions = [
    "key",
    "name",
    "default",
    "initial",
    "ready",
    "value",
    "label",
    "isRelevant",
    "isRequired",
    "isReadonly",
    "isValid",
    "meta",
    "hasValue",
    "isComplete",
    "separator",
];
function mapTermProperty(name, path, expression) {
    if (termPropertiesThatCanBeReferencedInExpressions.includes(name)) {
        return name;
    }
    else {
        throw new PathError(`Invalid term property name: ${name}`, path, expression);
    }
}
const iterablePropertiesThatCanBeReferencedInExpressions = ["count"];
function mapIterableProperty(name, path, expression) {
    if (iterablePropertiesThatCanBeReferencedInExpressions.includes(name)) {
        return name;
    }
    else {
        throw new PathError(`Invalid iterable property name: ${name}`, path, expression);
    }
}
//# sourceMappingURL=extract-dependencies.js.map